export default function IconDesignFileTextImage({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M27.7658 6.41562C28.0055 6.65522 28.1401 6.98021 28.1402 7.31911V29.4181C28.1402 29.757 28.0055 30.0821 27.7659 30.3217C27.5263 30.5613 27.2012 30.696 26.8623 30.696H5.13771C4.79878 30.696 4.47374 30.5613 4.23408 30.3217C3.99443 30.0821 3.85979 29.757 3.85979 29.4181V2.58187C3.85979 2.24295 3.99443 1.91791 4.23408 1.67825C4.47374 1.4386 4.79878 1.30396 5.13771 1.30396H22.1251C22.464 1.30403 22.7889 1.43872 23.0285 1.67839L27.7658 6.41562Z"
        fill="#E3E3E3"
      />
      <path
        d="M27.7658 6.41562L23.0285 1.67839C22.7889 1.43872 22.464 1.30403 22.1251 1.30396H5.13771C4.79878 1.30396 4.47374 1.4386 4.23408 1.67825C3.99443 1.91791 3.85979 2.24295 3.85979 2.58187V29.4181C3.85987 29.757 3.99455 30.082 4.23422 30.3216L27.9153 6.64054C27.874 6.56021 27.8239 6.48477 27.7658 6.41562Z"
        fill="white"
      />
      <path
        d="M27.7658 6.41562C28.0055 6.65522 28.1401 6.98021 28.1402 7.31911V29.4181C28.1402 29.757 28.0055 30.0821 27.7659 30.3217C27.5263 30.5613 27.2012 30.696 26.8623 30.696H5.13771C4.79878 30.696 4.47374 30.5613 4.23408 30.3217C3.99443 30.0821 3.85979 29.757 3.85979 29.4181V2.58187C3.85979 2.24295 3.99443 1.91791 4.23408 1.67825C4.47374 1.4386 4.79878 1.30396 5.13771 1.30396H22.1251C22.464 1.30403 22.7889 1.43872 23.0285 1.67839L27.7658 6.41562Z"
        stroke="#191919"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.3325 7.69354H19.1948"
        stroke="#191919"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.3325 11.5273H23.0285"
        stroke="#191919"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.3325 15.361H10.8883"
        stroke="#191919"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.3325 19.1948H10.8883"
        stroke="#191919"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.3325 23.0285H10.8883"
        stroke="#191919"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3065 17.9169V24.9454L22.2746 21.8912C22.2166 21.8053 22.1386 21.7349 22.0474 21.686C21.956 21.637 21.8543 21.6109 21.7506 21.6101C21.6453 21.603 21.5402 21.6241 21.4458 21.6713C21.3514 21.7185 21.2714 21.79 21.2139 21.8784L19.5143 24.3065L18.4664 23.463C18.3966 23.4094 18.3166 23.3703 18.2312 23.3483C18.146 23.3262 18.0571 23.3216 17.97 23.3347C17.8829 23.3478 17.7993 23.3784 17.7243 23.4246C17.6493 23.4708 17.5844 23.5317 17.5335 23.6036L15.361 26.8623C15.0221 26.8623 14.697 26.7276 14.4574 26.488C14.2178 26.2484 14.0831 25.9233 14.0831 25.5844V17.9169C14.0831 17.578 14.2178 17.2529 14.4574 17.0133C14.697 16.7737 15.0221 16.639 15.361 16.639H23.0285C23.3674 16.639 23.6925 16.7737 23.9322 17.0133C24.1718 17.2529 24.3065 17.578 24.3065 17.9169Z"
        fill="#66E1FF"
      />
      <path
        d="M24.3065 24.9454V25.5844C24.3065 25.9233 24.1718 26.2483 23.9322 26.488C23.6925 26.7276 23.3674 26.8623 23.0285 26.8623H15.361L17.5335 23.6036C17.5844 23.5317 17.6493 23.4707 17.7243 23.4246C17.7993 23.3783 17.8829 23.3478 17.97 23.3346C18.0571 23.3216 18.146 23.3262 18.2312 23.3482C18.3166 23.3703 18.3966 23.4092 18.4664 23.463L19.5143 24.3065L21.2139 21.8784C21.2714 21.79 21.3514 21.7184 21.4458 21.6713C21.5402 21.6241 21.6453 21.6029 21.7506 21.6101C21.8543 21.6108 21.956 21.6369 22.0474 21.686C22.1386 21.7349 22.2166 21.8053 22.2746 21.8912L24.3065 24.9454Z"
        fill="#78EB7B"
      />
      <path
        d="M24.3065 17.9169V24.9454L22.2746 21.8912C22.2166 21.8053 22.1386 21.7349 22.0474 21.686C21.956 21.637 21.8543 21.6109 21.7506 21.6101C21.6453 21.603 21.5402 21.6241 21.4458 21.6713C21.3514 21.7185 21.2714 21.79 21.2139 21.8784L19.5143 24.3065L18.4664 23.463C18.3966 23.4094 18.3166 23.3703 18.2312 23.3483C18.146 23.3262 18.0571 23.3216 17.97 23.3347C17.8829 23.3478 17.7993 23.3784 17.7243 23.4246C17.6493 23.4708 17.5844 23.5317 17.5335 23.6036L15.361 26.8623C15.0221 26.8623 14.697 26.7276 14.4574 26.488C14.2178 26.2484 14.0831 25.9233 14.0831 25.5844V17.9169C14.0831 17.578 14.2178 17.2529 14.4574 17.0133C14.697 16.7737 15.0221 16.639 15.361 16.639H23.0285C23.3674 16.639 23.6925 16.7737 23.9322 17.0133C24.1718 17.2529 24.3065 17.578 24.3065 17.9169Z"
        stroke="#191919"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3065 24.9454V25.5844C24.3065 25.9233 24.1718 26.2483 23.9322 26.488C23.6925 26.7276 23.3674 26.8623 23.0285 26.8623H15.361L17.5335 23.6036C17.5844 23.5317 17.6493 23.4707 17.7243 23.4246C17.7993 23.3783 17.8829 23.3478 17.97 23.3346C18.0571 23.3216 18.146 23.3262 18.2312 23.3482C18.3166 23.3703 18.3966 23.4092 18.4664 23.463L19.5143 24.3065L21.2139 21.8784C21.2714 21.79 21.3514 21.7184 21.4458 21.6713C21.5402 21.6241 21.6453 21.6029 21.7506 21.6101C21.8543 21.6108 21.956 21.6369 22.0474 21.686C22.1386 21.7349 22.2166 21.8053 22.2746 21.8912L24.3065 24.9454Z"
        stroke="#191919"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5974 19.8338C17.4209 19.8338 17.2779 19.6908 17.2779 19.5143C17.2779 19.3378 17.4209 19.1948 17.5974 19.1948"
        stroke="#191919"
        strokeWidth="1.33"
      />
      <path
        d="M17.5974 19.8338C17.7739 19.8338 17.9169 19.6908 17.9169 19.5143C17.9169 19.3378 17.7739 19.1948 17.5974 19.1948"
        stroke="#191919"
        strokeWidth="1.33"
      />
    </svg>
  )
}
